import styled from "@emotion/styled/macro";
import { Container } from "react-bootstrap";
import { IStyledComponentProps } from "../theme/theme.types";

export const ViewContainer = styled(Container)<IStyledComponentProps>`
  &.cms-soar-view-container {
    margin: 1.5em initial;
  }
`;
